import {
  PRE_ADD_USER_ADDRESS,
  PRE_UPDATE_USER_DATA,
  PRE_GET_USER_DATA,
  CHECK_FORM_USER,
  MISSING_FIELDS,
} from "../types/user.types";

export function addUserAddress(deliveryAddress) {
  return { type: PRE_ADD_USER_ADDRESS, payload: deliveryAddress };
}

export function getUserData(idUser) {
  return { type: PRE_GET_USER_DATA, payload: idUser };
}

export function updateUserData(userData, idUser) {
  return { type: PRE_UPDATE_USER_DATA, payload: { userData, idUser } };
}

export function displayMissingFields() {
  return { type: MISSING_FIELDS };
}

export function checkFormUser(formState, formName) {
  return { type: CHECK_FORM_USER, payload: { formState, formName } };
}
